import { TEntityOverride } from 'src/types'

const override: TEntityOverride = {
  titleField: 'name',
  global: {
    properties: {
      authorizedPassports: {
        displayedName: 'Authorized Passports',
        reference: {
          target: 'Passport',
          targetLabelKeyPath: 'username',
        },
      },
      groups: {
        type: 'groups',
      },
      imageId: {
        displayedName: 'Image Name',
        reference: {
          target: 'Image',
          targetLabelKeyPath: 'name',
        },
      },
    },
  },
  list: {
    properties: {
      imageId: {
        type: 'Image',
        displayedName: 'Image',
        reference: {
          target: 'Image',
          targetLabelKeyPath: 'imageData',
        },
      },
    },
  },
}

export default override
